// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.formItemInput[data-v-6dc01d90]{\n  width:300px;\n  margin-right: 20px;\n}\n.itemPrompt[data-v-6dc01d90]{\n}\n", ""]);
